import { ETAPES, ORANGE, TEAL, VERT, etapeEtat, fmtDate, fmtInstant } from './paniersProd'
import { avecAlpha } from '../../../lib/couleurs'

/**
 * Detail d'une tournee producteur : la TIMELINE VERTICALE des 5 etapes
 * (proto v7.3) — pastille numerotee (✓ si fait, pulsation si en cours),
 * sous-texte contextuel par etape, etapes futures grisees non cliquables.
 * Palier 1 : LECTURE — les ecrans d'etape sont consultatifs.
 */
function TourneeProd({ t, onOpenEtape }) {
  if (!t) return null

  const sousEtape = (i, s) => {
    if (i === 0) {
      if (s === 'avenir') return ''
      if (s === 'encours')
        return t.nbProduits === 0
          ? 'Choisissez vos produits depuis vos offres Paniers'
          : `${t.nbProduits} produit${t.nbProduits > 1 ? 's' : ''} saisi${t.nbProduits > 1 ? 's' : ''} — ajustable jusqu'à la clôture`
      return `${t.nbProduits} produit${t.nbProduits > 1 ? 's' : ''} proposé${t.nbProduits > 1 ? 's' : ''}`
    }
    if (i === 1) {
      const r = Number(t.totalReserve || 0)
      if (s === 'avenir') return 'Ouverture après la clôture des dispos'
      if (s === 'encours') return `Commandes jusqu'au ${fmtDate(t.dateClotureCommandes)} — ${r} réservés`
      return `${r} vendus`
    }
    if (i === 2) {
      if (s === 'avenir') return `Collecte prévue ${fmtDate(t.dateCollecte)}`
      if (s === 'encours') return `À préparer — collecte ${fmtDate(t.dateCollecte)}`
      return `Déposé le ${fmtDate(t.dateCollecte)}`
    }
    if (i === 3) return s === 'fait' ? `Livrée le ${fmtDate(t.dateLivraison)}` : `Livraison Manrina le ${fmtDate(t.dateLivraison)}`
    // Etape 5 — Mon argent
    if (!t.argent) return s === 'fait' ? 'Aucune vente en ligne sur cette tournée' : 'Après la livraison'
    if ((t.argent.netPrevisionnel ?? 0) > 0)
      return `Net en séquestre${t.argent.prochaineFenetreFin ? ` — fenêtre jusqu'au ${fmtInstant(t.argent.prochaineFenetreFin)}` : ''}`
    return t.versementMode === 'WALLET' ? 'Crédité sur votre wallet' : 'Versé sur votre compte'
  }

  return (
    <>
      <h1 className="font-serif text-[26px]" style={{ color: VERT }}>{t.nom || `Tournée du ${fmtDate(t.dateLivraison)}`}</h1>
      <p className="text-[12.5px] mt-1 text-ink/55">
        Livraison {fmtDate(t.dateLivraison)}{t.dateCollecte ? ` · collecte ${fmtDate(t.dateCollecte)}` : ''}
      </p>
      <div className="glass-surface rounded-3xl mt-3.5" style={{ padding: '18px 16px' }}>
        {ETAPES.map((e, i) => {
          const s = etapeEtat(t, i)
          const clic = s !== 'avenir'
          return (
            <div key={e.k} className="flex gap-3 relative">
              {/* colonne pastille + trait */}
              <div className="flex flex-col items-center flex-shrink-0" style={{ width: 26 }}>
                <span
                  className="rounded-full flex items-center justify-center font-extrabold flex-shrink-0"
                  style={{
                    width: 26, height: 26,
                    fontSize: s === 'fait' ? 13 : 11,
                    background: s === 'fait' ? TEAL : s === 'encours' ? ORANGE : 'rgba(7,62,61,0.08)',
                    color: s === 'avenir' ? 'rgba(7,62,61,0.4)' : s === 'fait' ? '#04302f' : VERT,
                    animation: s === 'encours' ? 'pulse 2s ease-in-out infinite' : 'none',
                  }}
                >
                  {s === 'fait' ? '✓' : i + 1}
                </span>
                {i < 4 && <span style={{ width: 2, flex: 1, minHeight: 22, background: s === 'fait' ? TEAL : 'rgba(7,62,61,0.1)' }} />}
              </div>
              <button
                disabled={!clic}
                onClick={() => onOpenEtape(e.scr)}
                className="flex-1 min-w-0 bg-transparent border-none text-left"
                style={{ padding: '2px 0 18px', opacity: s === 'avenir' ? 0.45 : 1, cursor: clic ? 'pointer' : 'default' }}
              >
                <div className="flex items-center gap-1.5">
                  <p className="text-sm font-extrabold flex-1" style={{ color: VERT }}>{e.e} {e.titre}</p>
                  {s === 'encours' && (
                    <span className="text-[9px] font-extrabold rounded-full" style={{ letterSpacing: 1, background: avecAlpha(ORANGE, 0.18), color: VERT, padding: '3px 8px' }}>
                      EN COURS
                    </span>
                  )}
                  {clic && <span className="text-[13px] text-ink/40">›</span>}
                </div>
                <p className="text-[11.5px] mt-1 leading-snug text-ink/60">{sousEtape(i, s)}</p>
              </button>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default TourneeProd
